"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveTypeName = resolveTypeName;

var _resolveJSType = require("./resolveJSType");

function resolveTypeName(value) {
  var jsType = (0, _resolveJSType.resolveJSType)(value);

  if (jsType !== 'object') {
    return jsType;
  }

  var obj = value;
  return '_type' in obj && obj._type || jsType;
}